const DistributorLogoThemes = {
  Default: "default",
  Light: "light",
  Icon: "icon",
} as const;

export type DistributorLogoTheme =
  (typeof DistributorLogoThemes)[keyof typeof DistributorLogoThemes];

export default DistributorLogoThemes;
